export default from './categories-page';



// WEBPACK FOOTER //
// ./app/containers/categories-page/index.js